const Modals = {
  addClub: "ADD_CLUB_MODAL",
  addSeason: "ADD_SEASON_MODAL",
  addRound: "ADD_ROUND_MODAL",
  importTeams: "IMPORT_TEAMS_MODAL",
};

export default Modals;
